<template>
  <div class="relative h-full w-full">
    <l-map
      ref="map"
      @ready="onReady()"
      class="h-full w-full z-0"
      :zoom="zoom"
      :maxZoom="maxZoom"
      :center="center"
      :options="{ zoomControl: true }"
    >
      <l-tile-layer :url="urlBasemap" :attribution="attribution"></l-tile-layer>
    </l-map>

    <buttons style="margin-top:65px; height: 100px;" 
      :geometries="geometries"
      @click="imgmap"    
      @createNew="createNew()"
      @saved="savedSuccesfully()"
      @showPointSelector="showPointSelector"
      @muestraLevantamientoModal = "muestraLevantamientoModal()"
    
    ></buttons>

    <div class="absolute right-0 top-0 z-10 mr-5" v-if="showCardCoords">
      <div class="mt-4 text-2xl font-medium tracking-widest">
        <span class="bg-primary-color px-40 py-2 text-white">Seleccione una ubicación en el mapa o
        </span>
        <br>
        <div class="flex">
          <button @click="showHelpModal"
            class="flex-shrink-0 z-10 bg-primary-blue-700 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 dark:border-gray-700 dark:text-white rounded-l-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.75 15V16.5H11.25V15H12.75ZM10.5 10.4318C10.5 9.66263 11.1497 9 12 9C12.8503 9 13.5 9.66263 13.5 10.4318C13.5 10.739 13.3151 11.1031 12.9076 11.5159C12.5126 11.9161 12.0104 12.2593 11.5928 12.5292L11.25 12.7509V14.25H12.75V13.5623C13.1312 13.303 13.5828 12.9671 13.9752 12.5696C14.4818 12.0564 15 11.3296 15 10.4318C15 8.79103 13.6349 7.5 12 7.5C10.3651 7.5 9 8.79103 9 10.4318H10.5Z"
                fill="#080341" />
            </svg>
          </button>
          <div class="relative w-full">
            <input type="text" placeholder="Pegue una url de google o coordenadas" @input="ValidateLink($event)"
              v-model="googleLink"
              class="block p-2 w-full z-20 text-sm bg-gray-50 rounded-r-lg border-l-gray-100 border-l-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500">
            <button @click="clearInput()"
              class="absolute top-0 right-0 p-3 h-full text-sm font-medium text-white bg-red-700 rounded-r-lg border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-blue-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
              <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                  fill="#0F1729" />
              </svg>
            </button>
          </div>
        </div>

        <span v-if="this.errorLink">Link no válido</span>
      </div>
    </div>

    <alert-dialog :showing="askingInfluenceZone">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Qué geometría desea dibujar?</div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-primary-color hover:bg-primary-color-dark"
          @click="askingInfluenceZone = false"
        >Marcador Común</button>
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-secondary-color hover:bg-secondary-color-dark"
          @click="askForRadio()"
        >Zona de Influencia</button>
      </div>
    </alert-dialog>


    <alert-dialog :showing="askingForRadioValue">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Introduce el valor del radio</div>
      </div>
      <div class="w-full">
          <input
            type="text"
            v-model="radioValue"
            placeholder="Radio en kilometros"
            class="w-full appearance-none border rounded py-2 px-3 mt-2 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
          />
      </div>
      <div class="mt-0 mb-2 w-1/4">
        <small>Kilómetros</small>
      </div>
      <div class="w-full">
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-secondary-color hover:bg-secondary-color-dark"
          @click="createInfluenceZone()"
        >Guardar</button>
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-red-500 hover:bg-cdmx-red"
          @click="askingForRadioValue = false"
        >Cerrar</button>
      </div>
    </alert-dialog>


    <div class="absolute inset-x-0 top-0 z-10" v-if="showHelpUser">
      <div class="mt-4 text-2xl font-medium tracking-widest">
        <span class="bg-primary-color px-40 py-2 text-white"
          >Seleccione una ubicación en el mapa</span
        >
      </div>
    </div>

    <levantamiento-modal
      :showing="showLevantamientoModal"
      :geometries="geometries"
      :latitud="0"
      :longitud="0"
      @close="closeLevantamientoModal()"
    ></levantamiento-modal>
    <help-modal class="w-full" :showing="showHelpCoordsModal" @close="closeHelpModal()"></help-modal>
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet.heat";
import "leaflet-geometryutil";
import EventBus from "../event-bus";
import buttons from "./Buttons";
import AlertDialog from "./AlertDialog";

import { stringify } from "wellknown/wellknown.js";
import * as turf from '@turf/turf';

import LevantamientoModal from "./LevantamientoModal";
import HelpModal from "./HelpModal.vue";

export default {
  name: "Map",
  data: function () {
    return {
      showNoticeModal: false,
      updateCluster: true,      
      zoom: 9,
      maxZoom: 18,
      center: [20.58651, -89.01501],
      map: null,
      showingSuccess: false,
      showingError: false,
      askingInfluenceZone: false,
      askingForRadioValue: false,        
      valor: { selectmap: "traffic" },
      coordsMarker: [0, 0],
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      showHelpUser: false,
      showLevantamientoModal: false,
      showHelpCoordsModal: false,
      markerLayer: null,
      urlMarker: null,
      drawMarker: null,
      isDrawing: false,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      latLngArray: [],
      geometries: [],
      buffers: [],
      radioValue: "2",
      radioValueParsed: 0,
      coordsMarker: [],
      markerInfluenceZone: "",
      circleInfluenceZone: "",
      circleInfluenceZoneLayer: "",
      editableLayers: "",
      layerBuffer: "",    
      showCardCoords: false,
      googleLink: "",
      errorLink: false,

    };
  },
  components: {
    LMap,
    LTileLayer,
    buttons,
    LevantamientoModal,
    AlertDialog,
    HelpModal
  },
  watch: {
    "valor.selectmap": function (val) {
      if (val === "traffic") {
        this.urlBasemap = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.attribution =
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
      } else {
        this.urlBasemap =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.attribution =
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community";
      }
    },
  },

  methods: {
    onReady() {
      console.log("onready")
      this.map = this.$refs.map.mapObject;
      this.markerLayer = new window.L.FeatureGroup().addTo(this.map);
      //let chapGeojson = L.geoJSON(this.geojsonChappultepec);
      //let chapBounds = chapGeojson.getBounds();
      //this.map.fitBounds(chapBounds);
      // esri.basemapLayer("Topographic").addTo(this.map);
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        // esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;
        this.editableLayers = new window.L.FeatureGroup().addTo(map);
        this.currentNoticeArea = this.editableLayers;

        // console.log(JSON.stringify(this.currentNoticeArea))
        console.log("drawControl")
        const drawControl = new window.L.Control.Draw({
          //position: "topright",
          position: "topleft",
          draw: {
            polyline: {
              showLength:true
            },
            polygon: {
              showArea:true,
              showLength:true
            },
            rectangle: true,
            circle: false,
            marker: true,
            circlemarker: false
          },
          edit: {
            featureGroup: this.editableLayers
          }
        });

        //agrega conroles de edicion
        const drawControlEditOnly = new window.L.Control.Draw({
          //position: "topright",
          position: "topleft",
          draw: {
            polyline: false,
            polygon: false,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          },
          edit: {
            featureGroup: this.editableLayers
          }
        });



        //map.addControl(drawControl);


        drawControl._toolbars.edit.disable =  function () {
          var that = this;
          console.log(this.geometries);
          

          if (!this.enabled()) {
            /* If you need to do something right as the
              edit tool is enabled, do it here right
              before the return */
            return;
          }

          this._activeMode.handler.revertLayers();
          /* If you need to do something when the
            cancel button is pressed and the edits
            are reverted, do it here. */
          console.log("cancel edit")
          console.log(that.editableLayers);


          that.map.removeLayer(this.geometries);

          this.editableLayers.clearLayers();

          L.Toolbar.prototype.disable.call(this);
        };

        this.controlAdd = drawControl;
        this.controlEdit = drawControlEditOnly;
        this.drawMarker = new L.Draw.Marker(this.map, this.controlAdd.options.marker);

        map.on("draw:created", e => {
          console.log("draw created")
          var layer = e.layer;
          var that = this;
          // console.log(layer)
          //this.noticeArea = layer.toGeoJSON().geometry;
          this.noticeArea = layer.toGeoJSON();
          // console.log("notice area en draw created");
          // console.log(this.noticeArea);
          this.noticeArea.properties = {}

          
          switch(this.noticeArea.geometry.type){
            case "Polygon":
              //this.noticeArea.properties.area = 23
              //this.noticeArea.properties.area = turf.area(this.noticeArea.geometry)/1000000 //en km2
              console.log(stringify(this.noticeArea))
              break;
            case "LineString":
              //this.noticeArea.properties.longitud = 54
              //this.noticeArea.properties.longitud = turf.length(this.noticeArea.geometry, {units: 'kilometers'})
              console.log(stringify(this.noticeArea))
              break;
            case "Point":
              //this.noticeArea.properties.longitud = 54
              //this.noticeArea.properties.position = {lat: this.noticeArea.geometry.coordinates[0], lng: this.noticeArea.geometry.coordinates[1] }
              console.log(stringify(this.noticeArea))
              break;              
          }
       //   console.log(this.noticeArea)
          console.log("editable layers antes de agregar")
          layer.addTo(this.editableLayers);
          console.log(this.editableLayers)
          this.noticeArea.properties.geomID = layer._leaflet_id

          this.geometries.push(this.noticeArea)
          // console.log(this.geometries)
          if (e.layerType == 'marker') {
            // console.log("la geometría es un marcador")
            this.askingInfluenceZone = true;
            this.coordsMarker = Array.from([layer._latlng.lat, layer._latlng.lng])

            // validar que el marcador sea de zona de influencia



            layer.on('dragend', function(event) {
              console.log("dragend al crear marcador");
              that.coordsMarker = Array.from([layer._latlng.lat, layer._latlng.lng])
              that.createInfluenceZoneByDragging(layer._leaflet_id, that.coordsMarker) // pasarle la nueva posicion del marcador
              
              console.log(that.coordsMarker);
            });

          }
          // map.removeControl(drawControl);
 //         drawControlEditOnly.addTo(map);
          //console.log(this.geometries)
        });

        map.on("draw:edited", e => {
          console.log("holaaas");
          let layersEdited = e.layers;
          console.log(e);
          const geomsCopy = JSON.parse(JSON.stringify(this.geometries))
          const geomsCopy2 = JSON.parse(JSON.stringify(this.geometries))
          const buffersCopy = this.buffers.map(function(e){return e;});
          var buffersDeleted = [] // arreglo donde se agregaran los buffers que se borren de marcadores editados
          var geomsEdited = []
          // console.log(layersEdited)

          // console.log("buffers al inicio");
          // console.log(this.buffers)
          // console.log("geometrias al inicio");
          // console.log(JSON.stringify(this.geometries));
          
          layersEdited.eachLayer(layer => {
            console.log(layer);
            geomsCopy.forEach(geom => {
              if( geom.properties.geomID == layer._leaflet_id ) {

                this.noticeArea = ""
                geomsEdited = []

                if( geom.properties.typeGeometry ) {
                  console.log("es buffer o marcador de buffer");
                  if( geom.properties.typeGeometry == "MarkerToBuffer") {
                    // es un marcador de buffer

                    geomsEdited.push(geom)

                    // borra el marcador de buffer del arreglo de geometrias
                    this.geometries = this.geometries.filter( function( g ) {
                      for( let i = 0; i < geomsEdited.length; i++ ) {
                        if( (geomsEdited[i].properties.geomID == g.properties.geomID) 
                        && (geomsEdited[i].properties.typeGeometry == g.properties.typeGeometry) ) {
                          return false;
                        }
                      }
                      return true;
                    });
                    // console.log(JSON.stringify(this.geometries));

                    // reconstruye y agrega nuevamente el marcador de buffer al arreglo de geometrías
                    this.noticeArea = layer.toGeoJSON()
                    this.noticeArea.properties = {}
                    this.noticeArea.properties.geomID = layer._leaflet_id
                    this.noticeArea.properties.typeGeometry = "MarkerToBuffer"
                    this.geometries.push(this.noticeArea);

                    geomsCopy2.forEach(geom2 => {

                      geomsEdited = []

                      if(( geom2.properties.geomID == layer._leaflet_id) && (geom2.properties.typeGeometry == "Buffer")) {
                        
                        geomsEdited.push(geom2)

                        // borra el buffer correspondiente del arreglo de geometrias
                        this.geometries = this.geometries.filter( function( g ) {
                          for( let i = 0; i < geomsEdited.length; i++ ) {
                            if( (geomsEdited[i].properties.geomID == g.properties.geomID) 
                            && (geomsEdited[i].properties.typeGeometry == g.properties.typeGeometry) ) {
                              return false;
                            }
                          }
                          return true;
                        });

                        // borra el buffer del mapa
                        buffersCopy.forEach(bff => {
                          if(geom2.properties.layerBufferID == bff._leaflet_id) {
                            if(map.hasLayer(bff)){
                              buffersDeleted.push(bff)
                              map.removeLayer(bff);
                            } else {
                              console.log("no hay buffer");
                            }
                          }
                        })

                        // borra el buffer del arreglo de buffers
                        this.buffers = this.buffers.filter( function( bff ) {
                          for( let i = 0; i < buffersDeleted.length; i++ ) {
                            if( buffersDeleted[i]._leaflet_id == bff._leaflet_id ) {
                              return false;
                            }
                          }
                          return true;
                        });

                        // reconstruye el buffer y lo agrega a los arreglos de geometrias y buffers
                        var idLayerBuffer = 0;
                        var radioBuffer = geom2.properties.radioValueParsed
                        var point = turf.point([layer._latlng.lng, layer._latlng.lat])
                        this.circleInfluenceZone = turf.buffer( point, radioBuffer, { units: 'kilometers' })
                        this.layerBuffer = L.layerGroup();
                        this.layerBuffer.addTo(map);
                        idLayerBuffer = this.layerBuffer._leaflet_id
                        this.noticeArea = L.geoJson(this.circleInfluenceZone)
                        this.layerBuffer.properties = {}
                        this.layerBuffer.properties.geomID = layer._leaflet_id
                        this.layerBuffer.addLayer(this.noticeArea)
                        this.buffers.push(this.layerBuffer)
                        this.noticeArea = this.noticeArea.toGeoJSON() 

                        this.noticeArea.type = {}
                        this.noticeArea.properties = {}
                        this.noticeArea.geometry = {}
                        this.noticeArea.type = this.noticeArea.features[0].type
                        this.noticeArea.properties = this.noticeArea.features[0].properties
                        this.noticeArea.geometry = this.noticeArea.features[0].geometry
                        this.noticeArea.properties.typeGeometry = ""
                        this.noticeArea.properties.typeGeometry = "Buffer"
                        this.noticeArea.properties.radioValueParsed = radioBuffer
                        this.noticeArea.properties.geomID = layer._leaflet_id  //asigna el mismo id que tiene el marcador
                        this.noticeArea.properties.layerBufferID = idLayerBuffer
                        delete this.noticeArea.features
                        this.geometries.push(this.noticeArea);
                      }
                    }) // <- fin del recorrido de geomsCopy2

                  } else {
                    // es un buffer, no hace nada
                  }
                } else {
                  console.log("no es buffer o marcador de buffer");

                  //borra la anterior geometria del arreglo de geometries
                  this.geometries = this.geometries.filter(function(geom) {
                    return geom.properties.geomID !== layer._leaflet_id; 
                  });

                  //agregar la geometria reconstruida al arreglo de geometries
                  this.noticeArea = layer.toGeoJSON();
                  this.noticeArea.properties = {}
                  this.noticeArea.properties.geomID = layer._leaflet_id
                  console.log(this.noticeArea)
                  this.geometries.push(this.noticeArea)
                }
              } else {
                //no hace nada
                console.log("el id de la geometria es diferente al de esta capa editada");
              }
            });
          });
          // console.log("buffers al final");
          // console.log(this.buffers)
          // console.log("geometrias al final");
          // console.log(JSON.stringify(this.geometries));
        });

        map.on("draw:deleted", e => {
          console.log("draw delete")
        
          var layersDeleted = e.layers //son las capas que se borraron despues de presionar "guardar"
          const geometriesCopy = JSON.parse(JSON.stringify(this.geometries))
          const buffersCopy = this.buffers.map(function(e){return e;});
          var buffersDeleted = [] //arreglo aux, para las capas buffers borrados del mapa
          // console.log(this.buffers);

          layersDeleted.eachLayer( layer => {
            // elimina buffers del mapa y del array de buffers
            for(let i = 0; i< geometriesCopy.length; i++) {
              if( geometriesCopy[i].properties.geomID == layer._leaflet_id ) {
                if( geometriesCopy[i].properties.typeGeometry) {
                  if(geometriesCopy[i].properties.typeGeometry == "Buffer") {
                    buffersCopy.forEach( bff => {
                      if( geometriesCopy[i].properties.layerBufferID == bff._leaflet_id ) { // eliminar el buffer correspondiente del arreglo de geometries y del mapa
                        if ( map.hasLayer(bff) ) {
                          // console.log(bff._leaflet_id); // id de buffers borrados
                          buffersDeleted.push(bff)
                          map.removeLayer(bff)  // remueve el buffer                    
                        }
                      }
                    })
                  }
                }
              }
            }
            
            // console.log(this.buffers);
            
            // Devuelve los elementos del array de geometrias que tengan
            // diferentes IDs de c/u de las capas borradas (foreach no func.)
            this.geometries = this.geometries.filter(function(geom) {
                return geom.properties.geomID !== layer._leaflet_id ; 
            });
            
          })

          // elimina del arreglo de buffers, todos los buffers removidos del mapa
          this.buffers = this.buffers.filter( function( bff ) {
            for( let i = 0; i < buffersDeleted.length; i++ ) {
              if( buffersDeleted[i]._leaflet_id == bff._leaflet_id ) {
                return false;
              }
            }
            return true;
          });

          // console.log(buffersDeleted);

          // console.log(this.geometries.length);
          // console.log(JSON.stringify(this.geometries));
          // console.log(this.buffers);
          // console.log(this.buffers.length);

          this.noticeArea = null;
          map.removeControl(drawControlEditOnly);
          drawControl.addTo(map);
        });
      });


    },
    imgmap: function (click) {
      if (click.mapa == "traffic") {
        this.valor.selectmap = click.mapa;
      } else if (click.mapa == "satellite") {
        this.valor.selectmap = click.mapa;
      }
    },

    createNew(){
      console.log("create newww")
      // console.log(this.buffers);
        
      if(this.buffers.length > 0) {
        this.buffers.forEach(bff => {
          // console.log(bff);
          this.map.eachLayer(function (layer){
            // console.log(layer);
            if(bff._leaflet_id == layer._leaflet_id) {
              // console.log("lo borra");
              layer.remove();
            }
          }); 
        });
          
      }

      this.buffers = []
      this.currentNoticeArea.clearLayers();
      //this.leafletMap.removeControl(this.controlEdit);
     // this.leafletMap.addControl(this.controlAdd);      
      this.geometries = [];
      this.leafletMap.removeControl(this.controlEdit);
      this.leafletMap.addControl(this.controlAdd);
      this.showCardCoords = true;
    },

    askForRadio() {
      this.geometries.forEach(geom => {
        if(this.noticeArea.properties.geomID == geom.properties.geomID) {
          this.noticeArea.properties.typeGeometry = "MarkerToBuffer"
        }
      })
      this.askingInfluenceZone = false;
      this.askingForRadioValue = true;
    },

    createInfluenceZone() {
      var idMarker = this.noticeArea.properties.geomID;
      var idLayerBuffer = 0;
      this.askingForRadioValue = false;   // cierra el modal para introducir el radio
      this.radioValueParsed = Number(this.radioValue);  // radio del círculo en kilometros
      var point = turf.point([this.coordsMarker[1], this.coordsMarker[0]]); // coordenadas para el centro del buffer (círculo)
      this.circleInfluenceZone = turf.buffer( point, this.radioValueParsed, {units: 'kilometers'} ) // forma el círculo
      
      //agregar propiedad radioValueParsed al marcador de buffer
      this.geometries.forEach(geometry => {
        if((this.noticeArea.properties.geomID == geometry.properties.geomID) 
        && (this.noticeArea.properties.typeGeometry == "MarkerToBuffer")) {
          this.noticeArea.properties.radioValueParsed = this.radioValueParsed
        }
      })

      console.log(JSON.stringify(this.geometries))

      this.layerBuffer = L.layerGroup();
      this.layerBuffer.addTo(this.map);
      idLayerBuffer = this.layerBuffer._leaflet_id
      this.noticeArea = L.geoJson(this.circleInfluenceZone)
      this.layerBuffer.properties = {}
      this.layerBuffer.properties.geomID = idMarker
      this.layerBuffer.addLayer(this.noticeArea)
      this.buffers.push(this.layerBuffer)
      console.log(this.buffers.length);
      this.noticeArea = this.noticeArea.toGeoJSON() 

      this.noticeArea.type = {}
      this.noticeArea.properties = {}
      this.noticeArea.geometry = {}
      this.noticeArea.type = this.noticeArea.features[0].type
      this.noticeArea.properties = this.noticeArea.features[0].properties
      this.noticeArea.geometry = this.noticeArea.features[0].geometry
      this.noticeArea.properties.typeGeometry = ""
      this.noticeArea.properties.typeGeometry = "Buffer"
      this.noticeArea.properties.radioValueParsed = this.radioValueParsed
      this.noticeArea.properties.geomID = idMarker  //asigna el mismo id que tiene el marcador
      this.noticeArea.properties.layerBufferID = idLayerBuffer
      delete this.noticeArea.features
      this.geometries.push(this.noticeArea);
      // this.editableLayers = new window.L.FeatureGroup().addTo(this.map);
      // noticeAreaLayer.addTo(this.editableLayers);
      // console.log("editable layers en create influence zone");
      // console.log(this.editableLayers)
    },

    createInfluenceZoneByDragging(idM, coordsM) {
      console.log(idM);
      console.log(coordsM);

      var idMarker = idM;
      var idLayerBuffer = 0;
      var that = this;

      const geomsCopy = JSON.parse(JSON.stringify(that.geometries))
      const geomsCopy2 = JSON.parse(JSON.stringify(that.geometries))
      const buffersCopy = that.buffers.map(function(e){return e;});
      var buffersDeleted = []
      var geomsEdited = []
    
      // this.askingForRadioValue = false;   // cierra el modal para introducir el radio

      that.geometries.forEach(geom => {
        if((geom.properties.geomID == idM) && (geom.properties.typeGeometry) && (geom.properties.typeGeometry == "Buffer")) {
          that.radioValueParsed = Number(geom.properties.radioValueParsed)
        }
      })

      var point = turf.point([coordsM[1], coordsM[0]]); // coordenadas para el centro del buffer (círculo)
      that.circleInfluenceZone = turf.buffer( point, that.radioValueParsed, {units: 'kilometers'} ) // forma el círculo
      

      geomsCopy2.forEach(geom2 => {

        geomsEdited = []

        if(( geom2.properties.geomID == idMarker) && (geom2.properties.typeGeometry) && (geom2.properties.typeGeometry == "Buffer")) {
          
          geomsEdited.push(geom2)

          // borra el buffer correspondiente del arreglo de geometrias
          that.geometries = that.geometries.filter( function( g ) {
            for( let i = 0; i < geomsEdited.length; i++ ) {
              if( (geomsEdited[i].properties.geomID == g.properties.geomID) 
              && (geomsEdited[i].properties.typeGeometry == g.properties.typeGeometry) ) {
                return false;
              }
            }
            return true;
          });

          // borra el buffer del mapa
          buffersCopy.forEach(bff => {
            if(geom2.properties.layerBufferID == bff._leaflet_id) {
              if(that.map.hasLayer(bff)){
                buffersDeleted.push(bff)
                that.map.removeLayer(bff);
              } else {
                console.log("no hay buffer");
              }
            }
          })

          // borra el buffer del arreglo de buffers
          that.buffers = that.buffers.filter( function( bff ) {
            for( let i = 0; i < buffersDeleted.length; i++ ) {
              if( buffersDeleted[i]._leaflet_id == bff._leaflet_id ) {
                return false;
              }
            }
            return true;
          });

        }
      }) // <- fin del recorrido de geomsCopy2

      console.log(JSON.stringify(this.geometries))

      that.layerBuffer = L.layerGroup();
      that.layerBuffer.addTo(that.map);
      idLayerBuffer = that.layerBuffer._leaflet_id
      that.noticeArea = L.geoJson(that.circleInfluenceZone)
      that.layerBuffer.properties = {}
      that.layerBuffer.properties.geomID = idMarker
      that.layerBuffer.addLayer(this.noticeArea)
      that.buffers.push(that.layerBuffer)
      console.log(that.buffers.length);
      that.noticeArea = that.noticeArea.toGeoJSON() 

      that.noticeArea.type = {}
      that.noticeArea.properties = {}
      that.noticeArea.geometry = {}
      that.noticeArea.type = that.noticeArea.features[0].type
      that.noticeArea.properties = that.noticeArea.features[0].properties
      that.noticeArea.geometry = that.noticeArea.features[0].geometry
      that.noticeArea.properties.typeGeometry = ""
      that.noticeArea.properties.typeGeometry = "Buffer"
      that.noticeArea.properties.radioValueParsed = that.radioValueParsed
      that.noticeArea.properties.geomID = idMarker  //asigna el matmo id que tiene el marcador
      that.noticeArea.properties.layerBufferID = idLayerBuffer
      delete that.noticeArea.features
      that.geometries.push(that.noticeArea);

    },

    muestraLevantamientoModal(){
      console.log("muestraLevantamientoModal")
      this.showLevantamientoModal = true;
    },

    showPointSelector() {
      if (!this.isDrawing) {
        /*this.showHelpUser = true;
        new L.Draw.Marker(this.map, this.controlAdd.options.marker).enable();
        this.isDrawing = true;*/
        this.showHelpUser = true;
        this.drawMarker.enable();
        this.isDrawing = true;
      }
    },
    closeLevantamientoModal() {
      //this.markerLayer.clearLayers();
      this.showLevantamientoModal = false;
      this.errorLink = false;
    },
    ValidateLink(e) {
      let link = e.target.value;
      if (link === "") {
        this.errorLink = false;
      } else {
        let urlreg1 = /([a-zA-Z]{3}\.)?google\.com(\.\w*)?/;
        let urlreg2 = /([a-zA-Z]{3}\.)?maps.app.goo.gl(\.\w*)?/;
        if (urlreg1.test(link)) {
          this.isDrawing = false;
          this.drawMarker.disable();
          const longUrlPattern = /3d([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?!4d([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?/gm;
          const middleUrlPattern = /(-?\d+\.\d+)+,+(-?\d+\.\d+)/gm
          if (longUrlPattern.test(link) && middleUrlPattern.test(link)) {
            console.log("link largo")
            let match = link.match(longUrlPattern)
            let coords = match[0].replace("3d", "").split("!4d")
            this.coordsMarker = Array.from([
              parseFloat(coords[0]),
              parseFloat(coords[1])
            ]);
            this.urlMarker = new L.Marker([parseFloat(coords[0]),
            parseFloat(coords[1])]);
            this.urlMarker.addTo(this.markerLayer);
          } else if (!longUrlPattern.test(link) && middleUrlPattern.test(link)) {
            console.log("link mediano", link);
            let match = link.match(middleUrlPattern)
            let coords = match[0].split(",")
            this.coordsMarker = Array.from([
              parseFloat(coords[0]),
              parseFloat(coords[1])
            ]);

            this.map.setZoom(20);
            this.map.panInside([parseFloat(coords[0]),parseFloat(coords[1])], {padding: [300, 500]})
            this.urlMarker = new L.Marker([parseFloat(coords[0]),
            parseFloat(coords[1])]);
            this.urlMarker.addTo(this.markerLayer);
          }
          
          this.googleLink = "";
          this.showHelpUser = false;
          this.showLevantamientoModal = true;
        } else if (urlreg2.test(link)) {
          console.log("link corto")
          this.axios.post("apidev/levantamientos/ValidateLink", {
            "link": link,
          },
            this.config
          )
            .then(response => {
              this.isDrawing = false;
              this.drawMarker.disable();
              this.coordsMarker = Array.from([
                parseFloat(response.data.lat),
                parseFloat(response.data.lng)
              ]);

            this.map.setZoom(20);
            this.map.panInside([parseFloat(coords[0]),parseFloat(coords[1])], {padding: [300, 500]})
              this.urlMarker = new L.Marker([parseFloat(response.data.lat),
              parseFloat(response.data.lng)]);
              this.urlMarker.addTo(this.markerLayer);
              this.googleLink = "";
              this.showHelpUser = false;
              this.showLevantamientoModal = true;
            })
            .catch(error => {
              console.log({ error })
            });
        } else if (link.includes(",")) {
          const coordsPattern = /([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?,([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?/gm
          if (coordsPattern.test(link.replace(' ', ''))) {
            this.isDrawing = false;
            this.drawMarker.disable();
            console.log("Coordenadas", link);
            let coords = link.split(",")

            this.coordsMarker = Array.from([
              parseFloat(coords[0]),
              parseFloat(coords[1])
            ]);
            this.urlMarker = new L.Marker([parseFloat(coords[0]),
            parseFloat(coords[1])]);

            this.map.setZoom(20);
            this.map.panInside([parseFloat(coords[0]),parseFloat(coords[1])], {padding: [300, 500]})
            this.urlMarker.addTo(this.markerLayer);
            this.googleLink = "";
            this.showHelpUser = false;
            //this.showLevantamientoModal = true;
            this.askingInfluenceZone = true
          } else {
            console.log("link no válido")
            this.errorLink = true;
          }

        } else {
          console.log("link no válido")
          this.errorLink = true;
        }
      }
    },
    clearInput: function (click) {
      this.googleLink = "";
      this.errorLink = false;
    },
    showHelpModal() {
      this.showHelpCoordsModal = true;
    },
    closeHelpModal() {
      this.showHelpCoordsModal = false;
    },
  },

  created() {
    let that = this;
  },
  mounted() {
    //this.getComplaints();
  },
  activated() {
    EventBus.$emit("updateNotification", {});
  },
  computed: {
    options() {
      return {
        pointToLayer: function (feature, latlng) {
          let color = "";
          let fillColor = "";

          switch (feature.properties.status) {
            case "no atendida":
              color = "#000";
              fillColor = "#cb2833";
              break;
            case "en proceso":
              color = "#000";
              fillColor = "#ffc200";
              break;
            case "Cerradas":
            case "atendida":
              color = "#000";
              fillColor = "#898d8d";
              break;
            default:
              color = "#000";
              fillColor = "#cb2833";
              break;
          }

          return L.circleMarker(latlng, {
            radius: 8,
            fillColor: fillColor,
            color: color,
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8,
          });
        },
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .leaflet-marker-label {
  width: auto !important;
  height: auto !important;
}

.leaflet-marker-iconlabel {
  background: #fff;
  border-radius: 7px;
  -moz-box-shadow: 0 3px 10px #888;
  -webkit-box-shadow: 0 3px 14px #999;
  box-shadow: 0 3px 10px #888;
  display: block;
  font: 11px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 4px 6px;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  white-space: nowrap;
} */


.leaflet-draw {
  margin-top: 250px !important;
  z-index: 10 !important;
}  


.leaflet-marker-label {
  width: auto !important;
  height: auto !important;
}

.leaflet-marker-iconlabel {
  background: #fff;
  border-radius: 7px;
  -moz-box-shadow: 0 3px 10px #888;
  -webkit-box-shadow: 0 3px 14px #999;
  box-shadow: 0 3px 10px #888;
  display: block;
  font: 11px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 4px 6px;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  white-space: nowrap;
}

.text-help-user {
  left: 50%;
  transform: translateX(-50%);
}
</style>
